import { render, staticRenderFns } from "./PageWidget.vue?vue&type=template&id=61a587d4&"
import script from "./PageWidget.vue?vue&type=script&lang=js&"
export * from "./PageWidget.vue?vue&type=script&lang=js&"
import style0 from "./PageWidget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports